import mixpanel from "mixpanel-browser/src/loaders/loader-module-core";

let mixpanelInstance: any;

const initMixpanelInstance = () => {
  mixpanel.init("971d8984157df1b1352ba539e0bc5cbe");
  mixpanelInstance = mixpanel;
};

export { mixpanelInstance, initMixpanelInstance };
